// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__2gGnN","tooltipWpapper":"Tooltip_tooltipWpapper__pfqaV"};